import ProductTile from "./ProductTile";
import { useDispatch } from "react-redux";
import { anchorProductToUrl } from "../../state/modules/search/productTile/actions";
import { analyticsProductClick } from "../../state/modules/analytics/actions";

const ConnectedProductTile = props => {
  const dispatch = useDispatch();

  return (
    <ProductTile
      {...props}
      analyticsProductClick={args => dispatch(analyticsProductClick(args))}
      anchorProductToUrl={args => dispatch(anchorProductToUrl(args))}
    />
  );
};

export default ConnectedProductTile;
